import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';

export const BlogTreeInitialDataFragment: GraphQLTaggedNode = graphql`
	fragment BlogTreeInitialData_query on Query
	@argumentDefinitions(
		spaceKey: { type: "String!" }
		includeBlogTree: { type: "Boolean!" }
		blogFirst: { type: "Int" }
		blogOrderBy: { type: "String" }
		blogStatuses: { type: "[String]" }
	) {
		blogPosts: content(
			spaceKey: $spaceKey
			type: "blogpost"
			first: $blogFirst
			orderby: $blogOrderBy
			status: $blogStatuses
		) @include(if: $includeBlogTree) {
			pageInfo {
				hasNextPage
				endCursor
			}
			nodes {
				...BlogTreeRootComponent_content @relay(mask: false)
			}
		}
	}
`;
